/* Presupuestos listos para pagar · lado de la web
 *
 * Manda el pedido (líneas, propiedades y archivos del diseño) al Worker de presupuestos, que crea un PEDIDO BORRADOR
 * de Shopify y devuelve su enlace de pago. No toca el carrito de quien lo prepara: se pueden hacer los que se quiera.
 * Si no hay dirección del Worker configurada (metacampo imprimirlo.presupuesto_url), los botones no se enseñan.
 *
 *   Presupuesto.crear(url, { titulo, nota, atributos, lineas: [{id, quantity, properties, archivos: {nombre: 'f0'}}],
 *                            ficheros: { f0: [File, 'nombre.png'] } })  ->  Promise<{ url, nombre, total }>
 *   Presupuesto.compartir(texto, btn)  ->  móvil: hoja de compartir; PC: copia el mensaje; si no, WhatsApp.
 */
(function () {
  'use strict';

  var ALTERNATIVAS = {
    'https://presupuesto.imprimirlo.com': 'https://presupuestos-imprimirlo.imprimirlo.workers.dev',
    'https://presupuestos-imprimirlo.imprimirlo.workers.dev': 'https://presupuesto.imprimirlo.com'
  };
  function fetchConPlazo(direccion, cuerpo, ms) {
    if (!ms || !window.AbortController) return fetch(direccion, { method: 'POST', body: cuerpo });
    var ctl = new AbortController(), t = setTimeout(function () { ctl.abort(); }, ms);
    return fetch(direccion, { method: 'POST', body: cuerpo, signal: ctl.signal }).then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }

  function sinRed() {
    var er = new Error('No se ha podido conectar con el servicio de presupuestos. Mira tu conexión (prueba con los datos del móvil o sin VPN ni bloqueadores) o escríbenos por WhatsApp y lo preparamos nosotros.');
    er.motivo = 'sin-red';
    return er;
  }

  async function crear(url, p) {
    var fd = new FormData();
    fd.append('datos', JSON.stringify({
      titulo: p.titulo || '', nota: p.nota || '', atributos: p.atributos || {}, lineas: p.lineas || [],
      codigo: p.codigo || '', modo: p.modo || ''   // modo «actualizar» + código: cambia ese mismo presupuesto en vez de crear otro
    }));
    Object.keys(p.ficheros || {}).forEach(function (k) {
      var f = p.ficheros[k];
      if (f && f[0]) fd.append(k, f[0], f[1] || f[0].name || k);
    });
    /* Si el navegador no consigue ni conectar con la dirección principal (DNS, bloqueo de la red, extensión…), se prueba la otra dirección del
       mismo Worker. Y si tampoco, un mensaje que se entienda en vez de «Failed to fetch». */
    var base = url.replace(/\/$/, '');
    var alt = ALTERNATIVAS[base];
    /* Algunas operadoras bloquean a ratos direcciones de Cloudflare (partidos de fútbol): la conexión se queda colgada ~1 minuto y acaba en
       «Failed to fetch». Una petición pequeña (sin archivos) tarda ~2 s: si en 8 s no hay respuesta se corta y se prueba la otra dirección, que
       es otra IP. Con archivos (subida lenta legítima) no se corta. */
    var pequena = !Object.keys(p.ficheros || {}).length;
    var res;
    try { res = await fetchConPlazo(base + '/presupuesto', fd, pequena && alt ? 8000 : 0); }
    catch (e1) {
      try { if (window.console) console.warn('Presupuesto: sin conexión con ' + base, e1); } catch (eC) { /* nada */ }
      if (!alt) throw sinRed();
      try { res = await fetchConPlazo(alt + '/presupuesto', fd, pequena ? 45000 : 0); }
      catch (e2) { try { if (window.console) console.warn('Presupuesto: sin conexión con ' + alt, e2); } catch (eC2) { /* nada */ } throw sinRed(); }
    }
    var j = null;
    try { j = await res.json(); } catch (e) { /* respuesta vacía */ }
    if (!res.ok || !j || !j.ok) { var er = new Error((j && j.error) || 'No se ha podido preparar el presupuesto.'); er.estado = res.status; er.motivo = (j && j.motivo) || ''; throw er; }
    return j;
  }

  function esMovil() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '') ||
      !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches && (navigator.maxTouchPoints || 0) > 1);
  }

  /* Comparte el texto (que ya lleva el enlace de pago). Devuelve 'compartido' | 'copiado' | 'whatsapp'. */
  async function compartir(texto) {
    if (esMovil() && navigator.share) {
      try { await navigator.share({ title: 'Presupuesto de Imprimirlo', text: texto }); return 'compartido'; }
      catch (e) { if (e && e.name === 'AbortError') return 'cancelado'; }
    }
    if (!esMovil()) {
      try { await navigator.clipboard.writeText(texto); return 'copiado'; } catch (e) {
        try {
          var ta = document.createElement('textarea'); ta.value = texto; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select(); var ok = document.execCommand('copy'); ta.remove();
          if (ok) return 'copiado';
        } catch (e2) { /* sigue */ }
      }
    }
    window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
    return 'whatsapp';
  }

  /* FLUJO (Xavi, 11/10): el botón dice «Crear presupuesto»; al pulsarlo se crea y el MISMO botón pasa a «Enviar presupuesto»,
     que lo manda (hoja de compartir en el móvil; en el ordenador copia el mensaje y abre el chat si no puede). Debajo ya no se
     enseña nada más. Si el cliente toca cualquier cosa del editor después, el presupuesto ya no coincide y el botón vuelve a
     «Crear presupuesto». Si no hay botón [data-presupuesto] cerca (ficha de ropa), se deja el aviso con sus botones de antes. */
  var CREAR = 'Crear presupuesto', ENVIAR = 'Enviar presupuesto';

  /* ---------- PDF para TODOS los productos (Xavi, 30/10/2026: «revisa que todos los productos puedan generar presupuestos en PDF») ----------
     Se maqueta con el mismo escritor que el del carrito (presupuesto-carrito.js, que se carga al pedirlo) a partir del texto del mensaje
     (título, detalle, precio, plazo, enlace), del total del Worker y, si el editor la tiene, de una imagen del montaje (`pres.imagenPdf`). */
  /* VERSIÓN del generador de PDF (presupuesto-carrito.js + pdf-fuentes.js): SUBIRLA cada vez que cambie cualquiera de los dos. La CDN guarda cada URL con su
     «?v=» y, si se reutilizara la versión de este fichero, seguiría sirviendo la copia vieja (le pasó a Xavi el 31/10: el PDF seguía con la letra rara). */
  var PDF_V = '20261031e';
  var SRC_PDF = ((document.currentScript && document.currentScript.src) || '').replace(/presupuesto\.js(\?.*)?$/, 'presupuesto-carrito.js?pdf=' + PDF_V);
  function cargarPdf() {
    if (window.PresupuestoPDF) return Promise.resolve();
    return new Promise(function (ok, ko) {
      if (!SRC_PDF) return ko(new Error('sin generador de PDF'));
      var sc = document.createElement('script'); sc.src = SRC_PDF; sc.onload = function () { window.PresupuestoPDF ? ok() : ko(new Error('sin generador de PDF')); };
      sc.onerror = function () { ko(new Error('sin generador de PDF')); }; document.head.appendChild(sc);
    });
  }
  function eurosDe(t) { var m = /(\d[\d.]*,\d{2})/.exec(String(t || '')); return m ? Math.round(parseFloat(m[1].replace(/\./g, '').replace(',', '.')) * 100) : 0; }
  function datosDeTexto(texto, pres) {
    var ls = String(texto || '').split('\n').map(function (l) { return l.trim(); }).filter(Boolean), titulo = 'Presupuesto', detalle = [], plazo = [], precio = '', enlace = '';
    ls.forEach(function (l, i) {
      var u = /(https?:\/\/\S+)/.exec(l);
      if (u) { enlace = u[1]; return; }
      if (i === 0) { titulo = l.replace(/^Presupuesto de Imprimirlo\s*·\s*/, '') || titulo; return; }
      if (/^Precio:/i.test(l)) { precio = l; return; }
      if (/^(entrega|recíbelo|recibelo|plazo|listo|lo tienes)/i.test(l)) { plazo.push(l); return; }
      detalle.push(l);
    });
    var total = pres && pres.total ? Math.round(parseFloat(pres.total) * 100) : eurosDe(precio);
    var uds = 1, ud = /(\d+)\s*(uds?\b|unidades|pegatinas|chapas|tarjetas|flyers|banderas|imanes|llaveros|parches)/i.exec(detalle.join(' ') + ' ' + titulo);
    if (ud) uds = Math.max(1, parseInt(ud[1], 10));
    return { titulo: titulo, detalle: detalle, plazo: plazo, total: total, uds: uds, enlace: (pres && pres.landing) || enlace };
  }
  async function pdfPresupuesto(texto, pres) {
    await cargarPdf();
    var P = window.PresupuestoPDF, d = datosDeTexto(texto, pres);
    var banda = await P.banda(), fu = await P.fuentes(), montajes = [];
    if (pres && pres.imagenPdf) { var im = await P.imagen(pres.imagenPdf, 720); if (im) montajes.push(im); }
    var base = Math.round(d.total / 1.21), filas = [{ tipo: 'prenda', texto: d.titulo, uds: d.uds, precio: P.centimos(Math.round(d.total / d.uds)), importe: P.centimos(d.total) }];
    d.detalle.concat(d.plazo).forEach(function (t) { P.trozos(t, 70).forEach(function (x) { filas.push({ tipo: 'nota', texto: x }); }); });
    return P.crear({ banda: banda, fuentes: fu, fecha: new Date().toLocaleDateString('es-ES'), montajes: montajes, filas: filas, total: P.centimos(d.total), base: P.centimos(base),
      iva: P.centimos(d.total - base), envio: d.total >= 6000 ? 'gratis' : '6,95 € (gratis desde 60 €)', enlace: d.enlace });
  }
  function bajarPdf(texto, pres, boton) {
    var antes = boton.textContent; boton.disabled = true; boton.textContent = 'Preparando el PDF…';
    return pdfPresupuesto(texto, pres).then(function (blob) {
      var u = URL.createObjectURL(blob), a = document.createElement('a');
      a.href = u; a.download = 'presupuesto-imprimirlo.pdf'; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
      boton.textContent = '✓ PDF descargado'; setTimeout(function () { boton.textContent = antes; boton.disabled = false; }, 2500);
    }, function () { boton.textContent = 'No se ha podido hacer el PDF'; setTimeout(function () { boton.textContent = antes; boton.disabled = false; }, 3000); });
  }
  // el botón «Descargar PDF» va justo debajo del de «Enviar presupuesto» y solo existe mientras el presupuesto sigue siendo válido
  function botonPdf(btn, texto, pres) {
    if (document.querySelector('[data-pres-pdf]')) return;      // la ficha de ropa ya tiene el suyo, con el desglose
    var b = btn._pdfBtn;
    if (!b) {
      b = document.createElement('button'); b.type = 'button'; b.className = btn.className; b.textContent = 'Descargar PDF';
      b.setAttribute('data-presupuesto-pdf', ''); b.style.cssText = (btn.getAttribute('style') || '') + ';margin-top:8px;width:100%';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (b._texto) bajarPdf(b._texto, b._pres, b); });
      btn.parentNode.insertBefore(b, btn.nextSibling); btn._pdfBtn = b;
    }
    b._texto = texto; b._pres = pres; b.hidden = false; b.disabled = false;
  }

  function botonDe(donde) {
    for (var n = donde; n && n !== document.body; n = n.parentNode) {
      var b = n.querySelector && n.querySelector('[data-presupuesto]');
      if (b) return b;
    }
    return null;
  }

  function mostrar(donde, pres, texto, copiado) {
    if (!donde) return;
    var btn = botonDe(donde);
    if (btn) {
      donde.hidden = true; donde.textContent = '';
      btn._envio = texto;
      btn.textContent = ENVIAR;
      botonPdf(btn, texto, pres);
      if (!btn._obs && window.MutationObserver) {
        btn._obs = new MutationObserver(function () {
          if (btn._envio && !btn._fb && btn.textContent !== ENVIAR) btn.textContent = ENVIAR;
        });
        btn._obs.observe(btn, { childList: true, characterData: true, subtree: true });
      }
      return;
    }
    donde.hidden = false;
    donde.textContent = '';
    var tt = document.createElement('b');
    tt.textContent = (copiado ? '✓ Copiado. ' : '') + 'Presupuesto ' + (pres.nombre || '') + ' listo' + (pres.totalTexto ? ' · ' + pres.totalTexto : '');
    donde.appendChild(tt);
    var fila = document.createElement('span');
    fila.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin-top:8px;align-items:center';
    var bC = document.createElement('button'); bC.type = 'button'; bC.textContent = 'Copiar mensaje';
    var bW = document.createElement('button'); bW.type = 'button'; bW.textContent = 'Enviar por WhatsApp';
    [bC, bW, bP].forEach(function (x) { x.style.cssText = 'border:1px solid currentColor;background:#fff;border-radius:8px;padding:6px 12px;font:inherit;cursor:pointer'; });
    var bP = document.createElement('button'); bP.type = 'button'; bP.textContent = 'Descargar PDF';
    var conPdfPropio = !!document.querySelector('[data-pres-pdf]');
    bP.addEventListener('click', function () { bajarPdf(texto, pres, bP); });
    bC.addEventListener('click', function () {
      var ok = function () { bC.textContent = '✓ Copiado'; };
      var plan = function () {
        try { var ta = document.createElement('textarea'); ta.value = texto; ta.style.cssText = 'position:fixed;opacity:0'; document.body.appendChild(ta); ta.select(); if (document.execCommand('copy')) ok(); ta.remove(); } catch (e2) { /* sin copiar */ }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(texto).then(ok, plan); else plan();
    });
    bW.addEventListener('click', function () { window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener'); });
    fila.appendChild(bC); fila.appendChild(bW); if (!conPdfPropio) fila.appendChild(bP); donde.appendChild(fila);
  }

  // «Enviar presupuesto»: se atiende antes que el manejador de la ficha, que crearía otro presupuesto
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-presupuesto]');
    if (!btn || !btn._envio) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var texto = btn._envio;
    compartir(texto).then(function (como) {
      if (como !== 'copiado') return;
      btn._fb = true; btn.textContent = '✓ Copiado: pégalo en el chat';
      setTimeout(function () { btn._fb = false; if (btn._envio) btn.textContent = ENVIAR; }, 3500);
    });
  }, true);

  // el presupuesto es de lo que había al crearlo: si el cliente cambia algo, hay que crear otro
  function caducar(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    document.querySelectorAll('[data-presupuesto]').forEach(function (btn) {
      if (!btn._envio || btn.contains(t)) return;
      var raiz = btn.closest('form, section, main, .page-width') || document.body;
      if (!raiz.contains(t)) return;
      if (t.closest('[data-presupuesto-nota]')) return;
      if (t.closest('[data-presupuesto-pdf]')) return;
      btn._envio = null; btn._fb = false; btn.textContent = CREAR; if (btn._pdfBtn) btn._pdfBtn.hidden = true;
    });
  }
  ['input', 'change', 'click', 'drop'].forEach(function (ev) { document.addEventListener(ev, caducar); });

  /* Convierte el formulario de una línea de carrito (id, quantity, properties[...] con archivos) en lo que pide `crear`:
     { lineas: [...], ficheros: {...} }. `extra` son líneas ya hechas ({ id, quantity, properties }). */
  function desdeForm(fd, extra) {
    var l = { id: null, quantity: 1, properties: {}, archivos: {} }, ficheros = {}, n = 0;
    fd.forEach(function (v, k) {
      if (k === 'id') l.id = v;
      else if (k === 'quantity') l.quantity = v;
      else {
        var m = /^properties\[(.*)\]$/.exec(k);
        if (!m) return;
        if (typeof Blob !== 'undefined' && v instanceof Blob) { var f = 'f' + (n++); ficheros[f] = [v, v.name || m[1]]; l.archivos[m[1]] = f; }
        else l.properties[m[1]] = String(v);
      }
    });
    var lineas = [l].concat((extra || []).map(function (e) { return { id: e.id, quantity: e.quantity, properties: e.properties || {}, archivos: {} }; }));
    return { lineas: lineas, ficheros: ficheros };
  }

  window.Presupuesto = { pdf: pdfPresupuesto, crear: crear, compartir: compartir, esMovil: esMovil, mostrar: mostrar, desdeForm: desdeForm };
})();
